export class MediaConstants {

    static MIN_WIDTH = "(min-width: 1100px)"; // Original is '(min-width: 768px)'

}